import { render } from "./ContactMe.vue?vue&type=template&id=3d383bcc&ts=true"
import script from "./ContactMe.vue?vue&type=script&lang=ts"
export * from "./ContactMe.vue?vue&type=script&lang=ts"

import exportComponent from "/var/www/admin.beepi.cl/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__